import { connect, StringCodec } from 'nats.ws';

export const subscribeToNATS = async (dataArray, onMessageCallback) => {
  const wsUrl = process.env.REACT_APP_NATS_WS_URL;
const username = process.env.REACT_APP_NATS_USERNAME;
const password = process.env.REACT_APP_NATS_PASSWORD;
  const sc = StringCodec();
  const nc = await connect({
    servers:wsUrl ,
    user:username ,
    pass:password,
  });

//   NATS_WS_URL = "wss://nats.stratx.in"
// USERNAME    = "stratxadmin"
// PASSWORD    = "VG4WdwCStra"
  console.log('✅ Connected to NATS');

  const subscriptions = [];

  for (const item of dataArray) {
    const subject = `${item.exchange}.${item.symbol}.${item.datafeed_symbol}`;
    const sub = nc.subscribe(subject);
    subscriptions.push(sub);

    (async () => {
      for await (const msg of sub) {
        const decoded = sc.decode(msg.data);
        const parsed = JSON.parse(decoded); // Contains live data like { last_price: ... }

        // Send raw values and original item to callback
        if (typeof onMessageCallback === 'function') {
          onMessageCallback({
            symbolData: item,
            message: parsed,
          });
        }
      }
    })();
  }

  return {
    close: async () => {
      subscriptions.forEach((sub) => sub.unsubscribe());
      await nc.close();
      console.log('🔌 NATS connection closed');
    },
  };
};
